import React from 'react';
import { Container, Grid, Button, Typography, Box } from '@mui/material';

const buttons = [
  {
    section: 'Customer Wise Sales',
    items: [
      { text: '1) Specific Customer Product Wise Sales.', url: '/all/custprosalesreport' },
      { text: '2) Specific Customer Specific Product & Date Range Wise Sales.', url: '/all/salereportrangespecific' },
      { text: '3) Specific Customer Date & Date Range Wise Sales.', url: '/all/custdatesalesreport' },
    ],
  },
  {
    section: 'Product Wise Sales',
    items: [
      { text: "1) All Product's Lifetime Sales.", url: '/all/proltsalesrReport' },
      { text: '2) Specific Product Date & Date Range Wise Sales.', url: '/all/prodatesalesreport' },
    ],
  },
  {
    section: 'Date Wise Sales',
    items: [
      { text: '1) Date Range Wise Sales.', url: '/all/daterangesalesreport' },
      { text: '2) Date Range Wise Sales Payment Due.', url: '/all/datesalespayduereport' },
      { text: '3) Test page.', url: '/all/salereporttestpage' },
    ],
  },
];

const SalesReportsPage = () => (
  <Box sx={{ background: "#fff", minHeight: "100vh", py: 4 }}>
    <Container maxWidth="lg">
      {buttons.map(section => (
        <Box key={section.section} mb={4}>
          <Typography
            variant="h6"
            fontWeight="bold"
            color="success.main"
            mb={2}
            className="section-heading"
          >
            {section.section}
          </Typography>
          <Grid container spacing={2}>
            {section.items.map(item => (
              <Grid item xs={12} sm={6} md={4} key={item.text}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  href={item.url}
                  target="_blank"
                  sx={{
                    // minHeight: 60,
                    width: '100%',                  // প্রতিটি বক্সের প্রস্থ Grid অনুযায়ী সমান
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    backgroundColor: '#f7fafc',
                    borderRadius: 2,
                    boxShadow: 1,
                    transition: '0.3s',
                    '&:hover': {
                      backgroundColor: '#1976d2',
                      color: '#fff',
                      borderColor: '#1976d2',
                      boxShadow: 3,
                    },
                  }}
                >
                  {item.text}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Container>
  </Box>
);

export default SalesReportsPage;